import { create } from "zustand";
import { AssetsColors } from "../../services";

const initialState: AssetsColors = {
  chains: {},
  tokens: {},
};

export const useAssetsColorsStore = create<AssetsColors>(() => initialState);
